import React from "react";
import TableRow from "./RecipTableRow";

export default function TableBody({data, handleEvents}) {
    const keyName = "recip-table";
    const colspan = 7;
    let list = [];
    for(const i in data) {
        list.push(<TableRow key={keyName+ "-row-" +i} data={data[i]} index={i} handleEvents={handleEvents} />);
    }
    if(data.length === 0) {
        list.push(<tr key={keyName+ "-row-1"}>
            <td key={keyName+ "-cell-0"} colSpan={colspan}>No email notification setup</td>
        </tr>);
    }
    return (<tbody key={keyName+ "-body"}>
        {list}
    </tbody>);
}